// This file is auto-generated by localize-js, do not make edits to this file directly
import { TranslatedStringTableFetcher, getStringProvider } from '@fluidx/localize-js';

export interface HostUxStrings {
  authorizationErrorTitle: string;
  authorizationErrorMessage: string;
  authorizationErrorBannerTitle: string;
  authorizationErrorBannerMessage: string;
  coauthorGalleryOverflowMenuHeader: (placeholders: { count: number; }) => string;
  close: string;
  editingStatus: string;
  errorBoundary: string;
  errorDialogTitle: string;
  criticalErrorBannerTitle: string;
  criticalErrorBannerMessage: string;
  fileNotFoundOrAccessDeniedTitle: string;
  fileNotFoundOrAccessDeniedMessage: string;
  fileNotFoundOrAccessDeniedBannerTitle: string;
  fileNotFoundOrAccessDeniedBannerMessage: string;
  componentNotFoundTitle: string;
  componentNotFoundMessage: string;
  containerUpgradeRequiredTitle: string;
  containerUpgradeRequiredMessage: string;
  containerUpgradeRequiredBannerTitle: string;
  containerUpgradeRequiredBannerMessage: string;
  genericErrorDialogTitle: string;
  genericErrorMessage: string;
  genericServiceBusyDialogTitle: string;
  genericServiceBusyMessage: string;
  genericServiceBusyBannerTitle: string;
  genericServiceBusyBannerMessage: string;
  giveFeedback: string;
  inactiveStatus: string;
  disconnectedStateBannerTitle: string;
  disconnectedStateBannerMessage: string;
  readonlyStateBannerTitle: string;
  readonlyStateBannerMessage: string;
  readonlyStateMobileBannerMessage: string;
  odspVersionMismatchBannerTitle: string;
  odspVersionMismatchBannerMessage: string;
  odspOutOfStorageDialogTitle: string;
  odspOutOfStorageMessage: string;
  odspOutOfStorageBannerTitle: string;
  odspOutOfStorageBannerMessage: string;
  navigateToFileLocationTitle: string;
  viewFileLocationButtonText: string;
  openInOffice: string;
  previewButtonLabel: string;
  previewLabelDialogTitle: string;
  previewLabelDialogTitleConsumer: string;
  previewLabelDialogFirstPara: string;
  previewLabelDialogFirstParaConsumer: string;
  previewLabelDialogSecondParaConsumer: string;
  previewLabelDialogGettingStartedLinkText: string;
  previewLabelDialogTermsLinkText: string;
  previewLabelDialogPrivacyLinkText: string;
  previewLabelDialogThirdPartyLinkText: string;
  previewLabelDialogConfirmButtonText: string;
  authorizeButtonText: string;
  reloadButtonText: string;
  upgradeButtonText: string;
  retryOpeningDocument: string;
  shareButtonText: string;
  shareDialogErrorMessage: string;
  shareDialogErrorTitle: string;
  copyDialogErrorTitle: string;
  shareFallbackCompanyName: string;
  componentUXWrapperAriaLabel: string;
  componentUXWrapperLoadingAriaLabel: string;
  componentAriaLabel: string;
  focusableComponentAriaLabel: string;
  actionMenuOverflowButtonTitle: string;
  lastEditedTooltipText: (placeholders: { authorName: string; relativeTimestamp: string; }) => string;
  lastEditedAriaLabelText: (placeholders: { relativeTimestamp: string; authorName: string; }) => string;
  relativeTimestampJustNow: string;
  relativeTimestampJustNowLowerCase: string;
  relativeTimestampMinutesAgo: (placeholders: { minutes: number; }) => string;
  relativeTimestampMinutesAgoFull: (placeholders: { minutes: number; }) => string;
  relativeTimestampHoursAgo: (placeholders: { hours: number; }) => string;
  relativeTimestampHoursAgoFull: (placeholders: { hours: number; }) => string;
  relativeTimestampYesterday: (placeholders: { time: string; }) => string;
  relativeTimestampYesterdayLowerCase: (placeholders: { time: string; }) => string;
  relativeTimestampWithinLastDays: (placeholders: { day: string; time: string; }) => string;
  permissionsEntrypointTitle: string;
  permissionsPanelTitle: string;
  permissionsPanelMultipleShareLinks: (placeholders: { count: number; }) => string;
  commandingSurfaceToggleBtnText: string;
  permissionsPanelGroupsTooltip: (placeholders: { count: number; }) => string;
  permissionsPanelSpecificPermissionText: string;
  copyLinkText: string;
  organizationWideEditLinkDescription: string;
  organizationWideViewLinkDescription: string;
  anonymousEditLinkDescription: string;
  anonymousViewLinkDescription: string;
  specificUsersEditLinkDescription: string;
  specificUsersViewLinkDescription: string;
  permissionsPanelFacepileAriaLabel: string;
  permissionsPanelOverflowButtonAriaLabel: (placeholders: { count: number; }) => string;
  permissionsPanelPeopleOutsideText: string;
  versionBannerTitle: string;
  versionBannerMessage: string;
}

export async function getHostUxStrings(translatedStringTableFetcher: TranslatedStringTableFetcher, locale: string): Promise<HostUxStrings> {
  const stringTableJson = await translatedStringTableFetcher(locale);
  return getStringProvider<HostUxStrings>(stringTableJson, locale);
}
